import { Empty, Loading } from 'components/LottieFiles';
import RewardItem from 'components/RewardItem';
import Title from 'components/Typography/Title';
import { PLACE_ID } from 'config/constant';
import { GET_OBJECTS } from 'config/queries';
import ChevronLeft from 'Icons/ChevronLeft';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import useRewards from 'store/useRewards';
import useUser from 'store/useUser';
import { AllWrapper, BackButton, Content, Grid } from './Rewards.styles';
import { getObjects } from './services';
import useSound from 'use-sound';
import ClickSound from 'assets/sounds/Tap.wav';
import { getImagefromMedia, getObject3D } from 'helpers/GlobalHelper';
import NoImage from 'assets/images/noImage.png';

const AllObjects = () => {
  const [playClick] = useSound(ClickSound);
  // states
  const { isLogged } = useUser();
  const { objects } = useRewards();
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const goBack = () => {
    playClick();
    navigate(-1);
  };
  const { t } = useTranslation();
  // get data
  const objectsList = useQuery(GET_OBJECTS, () => getObjects(PLACE_ID));

  // check if user logged

  useEffect(() => {
    if (!isLogged) {
      navigate('/start');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // check if objects is loaded or is stored on localestorage
    if (objects && !objectsList?.isLoading) {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [objects]);

  return (
    <AllWrapper>
      <BackButton onClick={goBack}>
        <ChevronLeft width="17" height="23" />
      </BackButton>
      <Content>
        <Title renderAs="h1" level={1}>
          {t('objectWon')}
        </Title>
        {objects && objects?.length > 0 ? (
          <Grid>
            {objects.map((object: any, index: number) => {
              const img = getImagefromMedia(object?.media);
              const object3d = getObject3D(object?.media)?.location;
              return (
                <RewardItem
                  key={object.name + index}
                  type="object"
                  name={object.name}
                  image={img || NoImage}
                  object3d={object3d || ''}
                  description={object.description}
                  is3D
                />
              );
            })}
          </Grid>
        ) : loading ? (
          <Loading />
        ) : (
          <Empty />
        )}
      </Content>
    </AllWrapper>
  );
};

export default AllObjects;
